/* Skapad av Claude Code — MASTER LP */
(function(){
  // Delad ATC-hjälpare: lägger items i varukorgen via /cart/add.js och
  // öppnar temats cart-drawer. Fallback → /cart om temats app.js saknas.
  function mlpCartAdd(items, btn){
    var restore = btn ? btn.textContent : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Lägger till…'; }
    return fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', 'Accept':'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(res){
      return res.json().then(function(data){
        if(!res.ok){ throw new Error(data.description || 'Kunde inte lägga till'); }
        if(typeof dispatchCustomEvent === 'function'){
          dispatchCustomEvent('cart:item-added', { product: data.items ? data.items[0] : data });
          dispatchCustomEvent('cart:refresh');
          dispatchCustomEvent('cart-drawer:open');
        } else {
          window.location.href = '/cart';
        }
        if(btn){ btn.disabled = false; btn.textContent = restore; }
      });
    }).catch(function(err){
      console.error('[mlp] cart error:', err);
      if(btn){
        btn.textContent = 'Fel – försök igen';
        setTimeout(function(){ btn.disabled = false; btn.textContent = restore; }, 2500);
      }
    });
  }

  // Köpblock (buy_box): radioval byter pris + hidden variant-id, submit → ATC.
  function initBuyBox(box){
    var form = box.querySelector('[data-mlp-buybox-form]');
    if(!form) return;
    var hidden = form.querySelector('[data-mlp-buybox-id]');
    var priceEl = box.querySelector('[data-mlp-buybox-price]');
    var nowEl = priceEl ? priceEl.querySelector('.mlp-buybox-price-now') : null;
    var wasEl = priceEl ? priceEl.querySelector('.mlp-buybox-price-was') : null;
    var variants = Array.prototype.slice.call(box.querySelectorAll('.mlp-buybox-variant'));

    function selectVariant(el){
      if(el.dataset.available === 'false') return;
      variants.forEach(function(v){
        v.classList.remove('mlp-buybox-variant--sel');
        v.setAttribute('aria-checked','false');
        v.setAttribute('tabindex','-1');
      });
      el.classList.add('mlp-buybox-variant--sel');
      el.setAttribute('aria-checked','true');
      el.setAttribute('tabindex','0');
      if(hidden) hidden.value = el.dataset.variantId;
      if(nowEl && el.dataset.price) nowEl.textContent = el.dataset.price;
      if(wasEl){
        if(el.dataset.compare){ wasEl.textContent = el.dataset.compare; wasEl.style.display = ''; }
        else { wasEl.textContent = ''; wasEl.style.display = 'none'; }
      }
    }
    variants.forEach(function(el){
      el.addEventListener('click', function(){ selectVariant(el); el.focus(); });
    });

    var atc = form.querySelector('[data-mlp-buybox-atc]');
    form.addEventListener('submit', function(e){
      e.preventDefault();
      var id = parseInt(hidden ? hidden.value : '', 10);
      if(!id || isNaN(id)) return;
      mlpCartAdd([{ id: id, quantity: 1 }], atc);
    });
  }

  // Förpackningar (package_picker): val av paket-kort + blå ATC.
  function initPackagePicker(pkg){
    var cards = Array.prototype.slice.call(pkg.querySelectorAll('.mlp-pkg-card'));
    var atc = pkg.querySelector('[data-mlp-pkg-atc]');
    if(!cards.length || !atc) return;
    var fallbackUrl = pkg.dataset.fallbackUrl || '/collections/all';

    function selectCard(card){
      cards.forEach(function(c){
        c.classList.remove('mlp-pkg-card--sel');
        c.setAttribute('aria-checked','false');
        c.setAttribute('tabindex','-1');
      });
      card.classList.add('mlp-pkg-card--sel');
      card.setAttribute('aria-checked','true');
      card.setAttribute('tabindex','0');
    }
    if(!pkg.querySelector('.mlp-pkg-card--sel')){ selectCard(cards[0]); }
    cards.forEach(function(card){
      card.addEventListener('click', function(){ selectCard(card); card.focus(); });
    });

    atc.addEventListener('click', function(){
      var sel = pkg.querySelector('.mlp-pkg-card--sel') || cards[0];
      var id = parseInt(sel && sel.dataset.variantId, 10);
      if(!id || isNaN(id)){ window.location.href = fallbackUrl; return; }
      mlpCartAdd([{ id: id, quantity: 1 }], atc);
    });
  }

  function init(root){
    if(root.dataset.mlpInit) return;
    root.dataset.mlpInit = '1';
    root.querySelectorAll('.mlp-buybox[data-mlp-buybox]').forEach(initBuyBox);
    root.querySelectorAll('.mlp-pkg[data-mlp-pkg]').forEach(initPackagePicker);
    // FAQ-dragspel m.m. registreras i senare tasks.
  }
  document.querySelectorAll('.mlp').forEach(init);
  document.addEventListener('shopify:section:load', function(e){
    e.target.querySelectorAll('.mlp').forEach(init);
  });
})();
